import { render, staticRenderFns } from "./page-section-secondary.vue?vue&type=template&id=02fce486&scoped=true&"
import script from "./page-section-secondary.vue?vue&type=script&lang=js&"
export * from "./page-section-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fce486",
  null
  
)

export default component.exports